module.exports = __webpack_public_path__ + "img/jacket-right-sub-setIn-classic.b10583ea.png";